import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "cdPlayerFilled"
const CdPlayerFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M10.5 12C11.327 12 12 12.672 12 13.5S11.327 15 10.5 15C9.67 15 9 14.328 9 13.5S9.67 12 10.5 12" />
          <path
            fillRule="evenodd"
            d="M10.5 4.687C11.99 4.687 13.394 5.058 14.624 5.711V6.346Q14.381 6.467 14.164 6.63C13.608 7.046 13.124 7.737 13.124 8.626 13.125 9.514 13.609 10.204 14.165 10.62 14.719 11.037 15.417 11.25 16.124 11.25 16.977 11.25 18.022 10.886 18.628 10.092 19.003 10.986 19.235 11.956 19.295 12.972H19.313L19.31 13.42 19.312 13.5Q19.31 14.007 19.253 14.499L19.23 14.689Q19.216 14.8 19.197 14.914 19.178 15.031 19.157 15.146 19.13 15.278 19.102 15.41L19.063 15.578 19.008 15.796 18.948 16.01Q18.854 16.32 18.741 16.617 18.695 16.742 18.644 16.865L18.569 17.042 18.549 17.088C17.983 18.352 17.131 19.458 16.073 20.323L15.76 20.59 15.749 20.579C14.282 21.668 12.466 22.312 10.499 22.312 5.81 22.312 1.976 18.65 1.704 14.027H1.686L1.688 13.532 1.687 13.5Q1.688 13.009 1.74 12.53 1.76 12.36 1.784 12.19L1.798 12.106Q1.826 11.926 1.86 11.75L1.885 11.64Q1.913 11.51 1.945 11.382 1.966 11.292 1.99 11.204 2.025 11.08 2.061 10.955L2.104 10.818 2.194 10.549 2.248 10.405Q2.3 10.262 2.359 10.123 2.385 10.058 2.414 9.995 2.465 9.875 2.52 9.759 2.565 9.661 2.614 9.565 2.652 9.487 2.694 9.409 2.753 9.296 2.816 9.184 2.862 9.1 2.91 9.02 2.986 8.894 3.065 8.77L3.135 8.662 3.238 8.507Q3.314 8.398 3.392 8.292L3.507 8.138Q3.586 8.036 3.667 7.935 3.718 7.871 3.773 7.809 3.825 7.746 3.88 7.685 3.98 7.572 4.085 7.46L4.163 7.378Q4.275 7.263 4.392 7.15L4.492 7.053 4.642 6.918Q4.724 6.845 4.809 6.773L4.867 6.723 4.902 6.693 5.239 6.41 5.249 6.42C6.717 5.331 8.534 4.687 10.5 4.687M5.12 8.012C3.83 9.278 2.981 10.993 2.835 12.907L7.555 12.924Q7.5 13.205 7.5 13.5C7.5 15.157 8.843 16.5 10.5 16.5 11.44 16.5 12.28 16.065 12.83 15.386L15.877 18.986C17.17 17.72 18.016 16.006 18.162 14.093L13.444 14.073Q13.498 13.795 13.499 13.5C13.5 11.843 12.157 10.5 10.5 10.5 9.558 10.5 8.718 10.934 8.168 11.613z"
            clipRule="evenodd"
          />
          <path d="M20.707 1.727C21.406 1.535 22.124 2.061 22.124 2.813V7.501L22.116 7.616C22.04 8.183 21.402 8.626 20.626 8.626 19.796 8.626 19.125 8.122 19.125 7.5 19.125 6.879 19.796 6.376 20.625 6.376V3.376L17.625 4.626V8.625L17.616 8.74Q17.61 8.794 17.597 8.845 17.553 9.001 17.46 9.138 17.43 9.184 17.393 9.226 17.284 9.356 17.133 9.458 17.083 9.49 17.03 9.523C16.814 9.645 16.552 9.725 16.27 9.746Q16.196 9.75 16.124 9.75 16.047 9.75 15.97 9.745 15.821 9.733 15.678 9.7 15.609 9.684 15.542 9.662 15.337 9.597 15.17 9.494 15.057 9.425 14.966 9.34C14.784 9.175 14.663 8.967 14.633 8.741Q14.625 8.684 14.625 8.626 14.625 8.566 14.632 8.51C14.71 7.943 15.348 7.5 16.125 7.5V4.375C16.125 3.921 16.398 3.512 16.817 3.337L20.567 1.775z" />
        </svg>
      }
    </span>
  )
}
export default CdPlayerFilledIcon
